export const getUserTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) {
    }
    return '';
};
export const isCampaignInCurrentYear = (campaign) => {
    const currentYear = new Date().getFullYear();
    const campaignYear = parseInt(campaign.slice(-4));
    return campaignYear === currentYear;
};
export const isCampaignInCurrentYearOrPrevious = (campaign) => {
    const currentYear = new Date().getFullYear();
    const campaignYear = parseInt(campaign.slice(-4));
    return campaignYear === currentYear || campaignYear === currentYear - 1;
};
export const isCampaignMTN = (campaign) => {
    return campaign.includes('mtn');
};
export const londonTimeZone = 'Europe/London';
export const timeZones = [
    {
        name: 'Europe/London',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Europe/London (GMT +0.00)'
    },
    {
        name: 'America/Los_Angeles',
        offset: '-08:00',
        altname: 'California',
        abbrev: 'PST',
        label: 'Los Angeles (PST -08:00)'
    },
    {
        name: 'Europe/Paris',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Paris (CET +01:00)'
    },
    {
        name: 'America/Phoenix',
        offset: '-07:00',
        altname: 'Phoenix, Arizona',
        abbrev: 'MST',
        label: 'Phoenix (MST -07:00)'
    },
    {
        name: 'America/Chicago',
        offset: '-06:00',
        altname: 'Chicago, Illinois',
        abbrev: 'CST',
        label: 'Chicago (CST -06:00)'
    },
    {
        name: 'Pacific/Pago_Pago',
        offset: '-11:00',
        altname: 'American Samoa',
        abbrev: 'SST',
        label: 'Pago Pago (SST -11:00)'
    },
    {
        name: 'Pacific/Niue',
        offset: '-11:00',
        altname: 'Niue',
        abbrev: 'NUT',
        label: 'Niue (NUT -11:00)'
    },
    {
        name: 'Pacific/Midway',
        offset: '-11:00',
        altname: 'Midway Island',
        abbrev: 'SST',
        label: 'Midway (SST -11:00)'
    },
    {
        name: 'Pacific/Rarotonga',
        offset: '-10:00',
        altname: 'Cook Islands',
        abbrev: 'CKT',
        label: 'Rarotonga (CKT -10:00)'
    },
    {
        name: 'Pacific/Tahiti',
        offset: '-10:00',
        altname: 'French Polynesia',
        abbrev: 'TAHT',
        label: 'Tahiti (TAHT -10:00)'
    },
    {
        name: 'America/Adak',
        offset: '-10:00',
        altname: 'Aleutian Islands',
        abbrev: 'HST',
        label: 'Adak (HST -10:00)'
    },
    {
        name: 'Pacific/Honolulu',
        offset: '-10:00',
        altname: 'Hawaii',
        abbrev: 'HST',
        label: 'Honolulu (HST -10:00)'
    },
    {
        name: 'Pacific/Marquesas',
        offset: '-09:30',
        altname: 'Marquesas Islands',
        abbrev: 'MART',
        label: 'Marquesas (MART -09:30)'
    },
    {
        name: 'Pacific/Gambier',
        offset: '-09:00',
        altname: 'Gambier Islands',
        abbrev: 'GAMT',
        label: 'Gambier (GAMT -09:00)'
    },
    {
        name: 'America/Anchorage',
        offset: '-09:00',
        altname: 'Alaska',
        abbrev: 'AKST',
        label: 'Anchorage (AKST -09:00)'
    },
    {
        name: 'America/Juneau',
        offset: '-09:00',
        altname: 'Juneau, Alaska',
        abbrev: 'AKST',
        label: 'Juneau (AKST -09:00)'
    },
    {
        name: 'America/Metlakatla',
        offset: '-09:00',
        altname: 'Metlakatla, Alaska',
        abbrev: 'AKST',
        label: 'Metlakatla (AKST -09:00)'
    },
    {
        name: 'America/Nome',
        offset: '-09:00',
        altname: 'Nome, Alaska',
        abbrev: 'AKST',
        label: 'Nome (AKST -09:00)'
    },
    {
        name: 'America/Sitka',
        offset: '-09:00',
        altname: 'Sitka, Alaska',
        abbrev: 'AKST',
        label: 'Sitka (AKST -09:00)'
    },
    {
        name: 'America/Yakutat',
        offset: '-09:00',
        altname: 'Yakutat, Alaska',
        abbrev: 'AKST',
        label: 'Yakutat (AKST -09:00)'
    },
    {
        name: 'America/Dawson',
        offset: '-08:00',
        altname: 'Dawson, Canada',
        abbrev: 'PST',
        label: 'Dawson (PST -08:00)'
    },
    {
        name: 'America/Vancouver',
        offset: '-08:00',
        altname: 'Vancouver, Canada',
        abbrev: 'PST',
        label: 'Vancouver (PST -08:00)'
    },
    {
        name: 'America/Whitehorse',
        offset: '-08:00',
        altname: 'Whitehorse, Canada',
        abbrev: 'PST',
        label: 'Whitehorse (PST -08:00)'
    },
    {
        name: 'America/Tijuana',
        offset: '-08:00',
        altname: 'Tijuana, Mexico',
        abbrev: 'PST',
        label: 'Tijuana (PST -08:00)'
    },
    {
        name: 'Pacific/Pitcairn',
        offset: '-08:00',
        altname: 'Pitcairn Islands',
        abbrev: 'PST',
        label: 'Pitcairn (PST -08:00)'
    },
    {
        name: 'America/Cambridge_Bay',
        offset: '-07:00',
        altname: 'Cambridge Bay, Canada',
        abbrev: 'MST',
        label: 'Cambridge Bay (MST -07:00)'
    },
    {
        name: 'America/Creston',
        offset: '-07:00',
        altname: 'Creston, Canada',
        abbrev: 'MST',
        label: 'Creston (MST -07:00)'
    },
    {
        name: 'America/Dawson_Creek',
        offset: '-07:00',
        altname: 'Dawson Creek, Canada',
        abbrev: 'MST',
        label: 'Dawson Creek (MST -07:00)'
    },
    {
        name: 'America/Edmonton',
        offset: '-07:00',
        altname: 'Edmonton, Canada',
        abbrev: 'MST',
        label: 'Edmonton (MST -07:00)'
    },
    {
        name: 'America/Fort_Nelson',
        offset: '-07:00',
        altname: 'Fort Nelson, Canada',
        abbrev: 'MST',
        label: 'Fort Nelson (MST -07:00)'
    },
    {
        name: 'America/Inuvik',
        offset: '-07:00',
        altname: 'Inuvik, Canada',
        abbrev: 'MST',
        label: 'Inuvik (MST -07:00)'
    },
    {
        name: 'America/Yellowknife',
        offset: '-07:00',
        altname: 'Yellowknife, Canada',
        abbrev: 'MST',
        label: 'Yellowknife (MST -07:00)'
    },
    {
        name: 'America/Chihuahua',
        offset: '-07:00',
        altname: 'Chihuahua, Mexico',
        abbrev: 'MST',
        label: 'Chihuahua (MST -07:00)'
    },
    {
        name: 'America/Hermosillo',
        offset: '-07:00',
        altname: 'Hermosillo, Mexico',
        abbrev: 'MST',
        label: 'Hermosillo (MST -07:00)'
    },
    {
        name: 'America/Mazatlan',
        offset: '-07:00',
        altname: 'Mazatlan, Mexico',
        abbrev: 'MST',
        label: 'Mazatlan (MST -07:00)'
    },
    {
        name: 'America/Ojinaga',
        offset: '-07:00',
        altname: 'Ojinaga, Mexico',
        abbrev: 'MST',
        label: 'Ojinaga (MST -07:00)'
    },
    {
        name: 'America/Boise',
        offset: '-07:00',
        altname: 'Boise, Idaho',
        abbrev: 'MST',
        label: 'Boise (MST -07:00)'
    },
    {
        name: 'America/Denver',
        offset: '-07:00',
        altname: 'Denver, Colorado',
        abbrev: 'MST',
        label: 'Denver (MST -07:00)'
    },
    {
        name: 'America/Belize',
        offset: '-06:00',
        altname: 'Belize',
        abbrev: 'CST',
        label: 'Belize (CST -06:00)'
    },
    {
        name: 'America/Rainy_River',
        offset: '-06:00',
        altname: 'Rainy River, Canada',
        abbrev: 'CST',
        label: 'Rainy River (CST -06:00)'
    },
    {
        name: 'America/Rankin_Inlet',
        offset: '-06:00',
        altname: 'Rankin Inlet, Canada',
        abbrev: 'CST',
        label: 'Rankin Inlet (CST -06:00)'
    },
    {
        name: 'America/Regina',
        offset: '-06:00',
        altname: 'Regina, Canada',
        abbrev: 'CST',
        label: 'Regina (CST -06:00)'
    },
    {
        name: 'America/Resolute',
        offset: '-06:00',
        altname: 'Resolute, Canada',
        abbrev: 'CST',
        label: 'Resolute (CST -06:00)'
    },
    {
        name: 'America/Swift_Current',
        offset: '-06:00',
        altname: 'Swift Current, Canada',
        abbrev: 'CST',
        label: 'Swift Current (CST -06:00)'
    },
    {
        name: 'America/Winnipeg',
        offset: '-06:00',
        altname: 'Winnipeg, Canada',
        abbrev: 'CST',
        label: 'Winnipeg (CST -06:00)'
    },
    {
        name: 'America/Costa_Rica',
        offset: '-06:00',
        altname: 'Costa Rica',
        abbrev: 'CST',
        label: 'Costa Rica (CST -06:00)'
    },
    {
        name: 'Pacific/Galapagos',
        offset: '-06:00',
        altname: 'Galapagos Time',
        abbrev: 'GALT',
        label: 'Pacific/Galapagos (GALT -06:00)'
    },
    {
        name: 'America/El_Salvador',
        offset: '-06:00',
        altname: 'El Salvador',
        abbrev: 'CST',
        label: 'El Salvador (CST -06:00)'
    },
    {
        name: 'America/Guatemala',
        offset: '-06:00',
        altname: 'Guatemala',
        abbrev: 'CST',
        label: 'Guatemala (CST -06:00)'
    },
    {
        name: 'America/Tegucigalpa',
        offset: '-06:00',
        altname: 'Honduras',
        abbrev: 'CST',
        label: 'Tegucigalpa (CST -06:00)'
    },
    {
        name: 'America/Bahia_Banderas',
        offset: '-06:00',
        altname: 'Bahia Banderas, Mexico',
        abbrev: 'CST',
        label: 'Bahia Banderas (CST -06:00)'
    },
    {
        name: 'America/Matamoros',
        offset: '-06:00',
        altname: 'Matamoros, Mexico',
        abbrev: 'CST',
        label: 'Matamoros (CST -06:00)'
    },
    {
        name: 'America/Merida',
        offset: '-06:00',
        altname: 'Merida, Mexico',
        abbrev: 'CST',
        label: 'Merida (CST -06:00)'
    },
    {
        name: 'America/Mexico_City',
        offset: '-06:00',
        altname: 'Mexico City, Mexico',
        abbrev: 'CST',
        label: 'Mexico City (CST -06:00)'
    },
    {
        name: 'America/Monterrey',
        offset: '-06:00',
        altname: 'Monterrey, Mexico',
        abbrev: 'CST',
        label: 'Monterrey (CST -06:00)'
    },
    {
        name: 'America/Managua',
        offset: '-06:00',
        altname: 'Nicaragua',
        abbrev: 'CST',
        label: 'Managua (CST -06:00)'
    },
    {
        name: 'America/Indiana/Knox',
        offset: '-06:00',
        altname: 'Knox, Indiana',
        abbrev: 'CST',
        label: 'Knox (CST -06:00)'
    },
    {
        name: 'America/Indiana/Tell_City',
        offset: '-06:00',
        altname: 'Tell City, Indiana',
        abbrev: 'CST',
        label: 'Tell City (CST -06:00)'
    },
    {
        name: 'America/Menominee',
        offset: '-06:00',
        altname: 'Menominee, Michigan',
        abbrev: 'CST',
        label: 'Menominee (CST -06:00)'
    },
    {
        name: 'America/North_Dakota/Beulah',
        offset: '-06:00',
        altname: 'Beulah, North Dakota',
        abbrev: 'CST',
        label: 'Beulah (CST -06:00)'
    },
    {
        name: 'America/North_Dakota/Center',
        offset: '-06:00',
        altname: 'Center, North Dakota',
        abbrev: 'CST',
        label: 'Center (CST -06:00)'
    },
    {
        name: 'America/North_Dakota/New_Salem',
        offset: '-06:00',
        altname: 'New Salem, North Dakota',
        abbrev: 'CST',
        label: 'New Salem (CST -06:00)'
    },
    {
        name: 'America/Nassau',
        offset: '-05:00',
        altname: 'Nassau, Bahamas',
        abbrev: 'EST',
        label: 'Nassau (EST -05:00)'
    },
    {
        name: 'America/Eirunepe',
        offset: '-05:00',
        altname: 'Eirunepe Time',
        abbrev: 'ACT',
        label: 'America/Eirunepe (ACT -05:00)'
    },
    {
        name: 'America/Rio_Branco',
        offset: '-05:00',
        altname: 'Rio Branco Time',
        abbrev: 'ACT',
        label: 'America/Rio_Branco (ACT -05:00)'
    },
    {
        name: 'America/Atikokan',
        offset: '-05:00',
        altname: 'Atikokan Time',
        abbrev: 'EST',
        label: 'America/Atikokan (EST -05:00)'
    },
    {
        name: 'America/Iqaluit',
        offset: '-05:00',
        altname: 'Iqaluit, Canada',
        abbrev: 'EST',
        label: 'Iqaluit (EST -05:00)'
    },
    {
        name: 'America/Nipigon',
        offset: '-05:00',
        altname: 'Nipigon Time',
        abbrev: 'EST',
        label: 'America/Nipigon (EST -05:00)'
    },
    {
        name: 'America/Pangnirtung',
        offset: '-05:00',
        altname: 'Pangnirtung Time',
        abbrev: 'EST',
        label: 'America/Pangnirtung (EST -05:00)'
    },
    {
        name: 'America/Thunder_Bay',
        offset: '-05:00',
        altname: 'Thunder Bay Time',
        abbrev: 'EST',
        label: 'America/Thunder_Bay (EST -05:00)'
    },
    {
        name: 'America/Toronto',
        offset: '-05:00',
        altname: 'Toronto, Canada',
        abbrev: 'EST',
        label: 'Toronto (EST -05:00)'
    },
    {
        name: 'America/Cayman',
        offset: '-05:00',
        altname: 'Cayman Islands',
        abbrev: 'EST',
        label: 'Cayman (EST -05:00)'
    },
    {
        name: 'Pacific/Easter',
        offset: '-05:00',
        altname: 'Easter Island',
        abbrev: 'EAST',
        label: 'Easter Island (EAST -05:00)'
    },
    {
        name: 'America/Bogota',
        offset: '-05:00',
        altname: 'Bogota, Colombia',
        abbrev: 'COT',
        label: 'Bogota (COT -05:00)'
    },
    {
        name: 'America/Havana',
        offset: '-05:00',
        altname: 'Havana, Cuba',
        abbrev: 'CST',
        label: 'Havana (CST -05:00)'
    },
    {
        name: 'America/Guayaquil',
        offset: '-05:00',
        altname: 'Guayaquil, Ecuador',
        abbrev: 'ECT',
        label: 'Guayaquil (ECT -05:00)'
    },
    {
        name: 'America/Port-au-Prince',
        offset: '-05:00',
        altname: 'Port-au-Prince, Haiti',
        abbrev: 'EST',
        label: 'Port-au-Prince (EST -05:00)'
    },
    {
        name: 'America/Jamaica',
        offset: '-05:00',
        altname: 'Jamaica',
        abbrev: 'EST',
        label: 'Jamaica (EST -05:00)'
    },
    {
        name: 'America/Cancun',
        offset: '-05:00',
        altname: 'Central Time',
        abbrev: 'CST',
        label: 'America/Cancun (CST -05:00)'
    },
    {
        name: 'America/Panama',
        offset: '-05:00',
        altname: 'Panama',
        abbrev: 'EST',
        label: 'Panama (EST -05:00)'
    },
    {
        name: 'America/Lima',
        offset: '-05:00',
        altname: 'Lima, Peru',
        abbrev: 'PET',
        label: 'Lima (PET -05:00)'
    },
    {
        name: 'America/Grand_Turk',
        offset: '-05:00',
        altname: 'Eastern Time',
        abbrev: 'EST',
        label: 'America/Grand_Turk (EST -05:00)'
    },
    {
        name: 'America/Detroit',
        offset: '-05:00',
        altname: 'Eastern Time',
        abbrev: 'EST',
        label: 'America/Detroit (EST -05:00)'
    },
    {
        name: 'America/Indiana/Indianapolis',
        offset: '-05:00',
        altname: 'Indianapolis, Indiana',
        abbrev: 'EST',
        label: 'Indianapolis (EST -05:00)'
    },
    {
        name: 'America/Indiana/Marengo',
        offset: '-05:00',
        altname: 'Marengo, Indiana',
        abbrev: 'EST',
        label: 'Marengo (EST -05:00)'
    },
    {
        name: 'America/Indiana/Petersburg',
        offset: '-05:00',
        altname: 'Petersburg, Indiana',
        abbrev: 'EST',
        label: 'Petersburg (EST -05:00)'
    },
    {
        name: 'America/Indiana/Vevay',
        offset: '-05:00',
        altname: 'Eastern Time',
        abbrev: 'EST',
        label: 'America/Indiana/Vevay (EST -05:00)'
    },
    {
        name: 'America/Indiana/Vincennes',
        offset: '-05:00',
        altname: 'Vincennes, Indiana',
        abbrev: 'EST',
        label: 'Vincennes (EST -05:00)'
    },
    {
        name: 'America/Indiana/Winamac',
        offset: '-05:00',
        altname: 'Winamac, Indiana',
        abbrev: 'EST',
        label: 'Winamac (EST -05:00)'
    },
    {
        name: 'America/Kentucky/Louisville',
        offset: '-05:00',
        altname: 'Eastern Time',
        abbrev: 'EST',
        label: 'America/Kentucky/Louisville (EST -05:00)'
    },
    {
        name: 'America/Kentucky/Monticello',
        offset: '-05:00',
        altname: 'Eastern Time',
        abbrev: 'EST',
        label: 'America/Kentucky/Monticello (EST -05:00)'
    },
    {
        name: 'America/New_York',
        offset: '-05:00',
        altname: 'New York, New York',
        abbrev: 'EST',
        label: 'New York (EST -05:00)'
    },
    {
        name: 'America/Anguilla',
        offset: '-04:00',
        altname: 'Anguilla',
        abbrev: 'AST',
        label: 'Anguilla (AST -04:00)'
    },
    {
        name: 'America/Antigua',
        offset: '-04:00',
        altname: 'Antigua and Barbuda',
        abbrev: 'AST',
        label: 'Antigua (AST -04:00)'
    },
    {
        name: 'America/Aruba',
        offset: '-04:00',
        altname: 'Aruba',
        abbrev: 'AST',
        label: 'Aruba (AST -04:00)'
    },
    {
        name: 'America/Barbados',
        offset: '-04:00',
        altname: 'Barbados',
        abbrev: 'AST',
        label: 'Barbados (AST -04:00)'
    },
    {
        name: 'Atlantic/Bermuda',
        offset: '-04:00',
        altname: 'Bermuda',
        abbrev: 'ADT',
        label: 'Bermuda (ADT -04:00)'
    },
    {
        name: 'America/La_Paz',
        offset: '-04:00',
        altname: 'Bolivia Time',
        abbrev: 'BOT',
        label: 'America/La_Paz (BOT -04:00)'
    },
    {
        name: 'America/Kralendijk',
        offset: '-04:00',
        altname: 'Kralendijk, Bonaire',
        abbrev: 'AST',
        label: 'Kralendijk (AST -04:00)'
    },
    {
        name: 'America/Boa_Vista',
        offset: '-04:00',
        altname: 'Boa Vista, Brazil',
        abbrev: 'AMT',
        label: 'Boa Vista (AMT -04:00)'
    },
    {
        name: 'America/Campo_Grande',
        offset: '-04:00',
        altname: 'Campo Grande, Brazil',
        abbrev: 'AMST',
        label: 'Campo Grande (AMST -04:00)'
    },
    {
        name: 'America/Cuiaba',
        offset: '-04:00',
        altname: 'Cuiaba, Brazil',
        abbrev: 'AMST',
        label: 'Cuiaba (AMST -04:00)'
    },
    {
        name: 'America/Manaus',
        offset: '-04:00',
        altname: 'Amazon Time',
        abbrev: 'AMT',
        label: 'America/Manaus (AMT -04:00)'
    },
    {
        name: 'America/Porto_Velho',
        offset: '-04:00',
        altname: 'Porto Velho, Brazil',
        abbrev: 'AMT',
        label: 'Porto Velho (AMT -04:00)'
    },
    {
        name: 'America/Tortola',
        offset: '-04:00',
        altname: 'Tortola, British Virgin Islands',
        abbrev: 'AST',
        label: 'Tortola (AST -04:00)'
    },
    {
        name: 'America/Blanc-Sablon',
        offset: '-04:00',
        altname: 'Blanc-Sablon, Canada',
        abbrev: 'AST',
        label: 'Blanc-Sablon (AST -04:00)'
    },
    {
        name: 'America/Glace_Bay',
        offset: '-04:00',
        altname: 'Atlantic Standard Time',
        abbrev: 'AST',
        label: 'America/Glace_Bay (AST -04:00)'
    },
    {
        name: 'America/Goose_Bay',
        offset: '-04:00',
        altname: 'Atlantic Standard Time',
        abbrev: 'AST',
        label: 'America/Goose_Bay (AST -04:00)'
    },
    {
        name: 'America/Halifax',
        offset: '-04:00',
        altname: 'Atlantic Standard Time',
        abbrev: 'AST',
        label: 'America/Halifax (AST -04:00)'
    },
    {
        name: 'America/Moncton',
        offset: '-04:00',
        altname: 'Atlantic Standard Time',
        abbrev: 'AST',
        label: 'America/Moncton (AST -04:00)'
    },
    {
        name: 'America/Curacao',
        offset: '-04:00',
        altname: 'Curacao',
        abbrev: 'AST',
        label: 'Curacao (AST -04:00)'
    },
    {
        name: 'America/Dominica',
        offset: '-04:00',
        altname: 'Dominica',
        abbrev: 'AST',
        label: 'Dominica (AST -04:00)'
    },
    {
        name: 'America/Santo_Domingo',
        offset: '-04:00',
        altname: 'Santo Domingo, Dominican Republic',
        abbrev: 'AST',
        label: 'Santo Domingo (AST -04:00)'
    },
    {
        name: 'America/Thule',
        offset: '-04:00',
        altname: 'Thule, Greenland',
        abbrev: 'AST',
        label: 'Thule (AST -04:00)'
    },
    {
        name: 'America/Grenada',
        offset: '-04:00',
        altname: 'Grenada',
        abbrev: 'AST',
        label: 'Grenada (AST -04:00)'
    },
    {
        name: 'America/Guadeloupe',
        offset: '-04:00',
        altname: 'Guadeloupe',
        abbrev: 'AST',
        label: 'Guadeloupe (AST -04:00)'
    },
    {
        name: 'America/Guyana',
        offset: '-04:00',
        altname: 'Guyana',
        abbrev: 'GYT',
        label: 'Guyana (GYT -04:00)'
    },
    {
        name: 'America/Martinique',
        offset: '-04:00',
        altname: 'Martinique',
        abbrev: 'AST',
        label: 'Martinique (AST -04:00)'
    },
    {
        name: 'America/Montserrat',
        offset: '-04:00',
        altname: 'Montserrat',
        abbrev: 'AST',
        label: 'Montserrat (AST -04:00)'
    },
    {
        name: 'America/Puerto_Rico',
        offset: '-04:00',
        altname: 'Puerto Rico',
        abbrev: 'AST',
        label: 'Puerto Rico (AST -04:00)'
    },
    {
        name: 'America/St_Barthelemy',
        offset: '-04:00',
        altname: 'St. Barthelemy',
        abbrev: 'AST',
        label: 'St. Barthelemy (AST -04:00)'
    },
    {
        name: 'America/St_Kitts',
        offset: '-04:00',
        altname: 'St. Kitts',
        abbrev: 'AST',
        label: 'St. Kitts (AST -04:00)'
    },
    {
        name: 'America/St_Lucia',
        offset: '-04:00',
        altname: 'St. Lucia',
        abbrev: 'AST',
        label: 'St. Lucia (AST -04:00)'
    },
    {
        name: 'America/Marigot',
        offset: '-04:00',
        altname: 'Marigot, Saint Martin',
        abbrev: 'AST',
        label: 'Marigot (AST -04:00)'
    },
    {
        name: 'America/St_Vincent',
        offset: '-04:00',
        altname: 'St. Vincent',
        abbrev: 'AST',
        label: 'St. Vincent (AST -04:00)'
    },
    {
        name: 'America/Lower_Princes',
        offset: '-04:00',
        altname: 'Lower Princes, Sint Maarten',
        abbrev: 'AST',
        label: 'Lower Princes (AST -04:00)'
    },
    {
        name: 'America/Port_of_Spain',
        offset: '-04:00',
        altname: 'Port of Spain, Trinidad and Tobago',
        abbrev: 'AST',
        label: 'Port of Spain (AST -04:00)'
    },
    {
        name: 'America/St_Thomas',
        offset: '-04:00',
        altname: 'St. Thomas, U.S. Virgin Islands',
        abbrev: 'AST',
        label: 'St. Thomas (AST -04:00)'
    },
    {
        name: 'America/Caracas',
        offset: '-04:00',
        altname: 'Caracas, Venezuela',
        abbrev: 'VET',
        label: 'Caracas (VET -04:00)'
    },
    {
        name: 'America/St_Johns',
        offset: '-03:30',
        altname: 'St. Johns, Canada',
        abbrev: 'NST',
        label: 'St. Johns (NST -03:30)'
    },
    {
        name: 'Antarctica/Palmer',
        offset: '-03:00',
        altname: 'Palmer Station, Antarctica',
        abbrev: 'CLT',
        label: 'Palmer (CLT -03:00)'
    },
    {
        name: 'Antarctica/Rothera',
        offset: '-03:00',
        altname: 'Rothera Time',
        abbrev: 'ROTT',
        label: 'Antarctica/Rothera (ROTT -03:00)'
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        offset: '-03:00',
        altname: 'Buenos Aires, Argentina',
        abbrev: 'ART',
        label: 'Buenos Aires (ART -03:00)'
    },
    {
        name: 'America/Argentina/Catamarca',
        offset: '-03:00',
        altname: 'Catamarca, Argentina',
        abbrev: 'ART',
        label: 'Catamarca (ART -03:00)'
    },
    {
        name: 'America/Argentina/Cordoba',
        offset: '-03:00',
        altname: 'Cordoba, Argentina',
        abbrev: 'ART',
        label: 'Cordoba (ART -03:00)'
    },
    {
        name: 'America/Argentina/Jujuy',
        offset: '-03:00',
        altname: 'Jujuy, Argentina',
        abbrev: 'ART',
        label: 'Jujuy (ART -03:00)'
    },
    {
        name: 'America/Argentina/La_Rioja',
        offset: '-03:00',
        altname: 'La Rioja, Argentina',
        abbrev: 'ART',
        label: 'La Rioja (ART -03:00)'
    },
    {
        name: 'America/Argentina/Mendoza',
        offset: '-03:00',
        altname: 'Mendoza, Argentina',
        abbrev: 'ART',
        label: 'Mendoza (ART -03:00)'
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        offset: '-03:00',
        altname: 'Rio Gallegos, Argentina',
        abbrev: 'ART',
        label: 'Rio Gallegos (ART -03:00)'
    },
    {
        name: 'America/Argentina/Salta',
        offset: '-03:00',
        altname: 'Salta, Argentina',
        abbrev: 'ART',
        label: 'Salta (ART -03:00)'
    },
    {
        name: 'America/Argentina/San_Juan',
        offset: '-03:00',
        altname: 'San Juan, Argentina',
        abbrev: 'ART',
        label: 'San Juan (ART -03:00)'
    },
    {
        name: 'America/Argentina/San_Luis',
        offset: '-03:00',
        altname: 'San Luis, Argentina',
        abbrev: 'ART',
        label: 'San Luis (ART -03:00)'
    },
    {
        name: 'America/Argentina/Tucuman',
        offset: '-03:00',
        altname: 'Tucuman, Argentina',
        abbrev: 'ART',
        label: 'Tucuman (ART -03:00)'
    },
    {
        name: 'America/Argentina/Ushuaia',
        offset: '-03:00',
        altname: 'Ushuaia, Argentina',
        abbrev: 'ART',
        label: 'Ushuaia (ART -03:00)'
    },
    {
        name: 'America/Araguaina',
        offset: '-03:00',
        altname: 'Araguaina Time',
        abbrev: 'BRT',
        label: 'America/Araguaina (BRT -03:00)'
    },
    {
        name: 'America/Bahia',
        offset: '-03:00',
        altname: 'Bahia, Brazil',
        abbrev: 'BRT',
        label: 'Bahia (BRT -03:00)'
    },
    {
        name: 'America/Belem',
        offset: '-03:00',
        altname: 'Belem, Brazil',
        abbrev: 'BRT',
        label: 'Belem (BRT -03:00)'
    },
    {
        name: 'America/Fortaleza',
        offset: '-03:00',
        altname: 'Fortaleza, Brazil',
        abbrev: 'BRT',
        label: 'Fortaleza (BRT -03:00)'
    },
    {
        name: 'America/Maceio',
        offset: '-03:00',
        altname: 'Maceio, Brazil',
        abbrev: 'BRT',
        label: 'Maceio (BRT -03:00)'
    },
    {
        name: 'America/Recife',
        offset: '-03:00',
        altname: 'Recife, Brazil',
        abbrev: 'BRT',
        label: 'Recife (BRT -03:00)'
    },
    {
        name: 'America/Santarem',
        offset: '-03:00',
        altname: 'Santarem, Brazil',
        abbrev: 'BRT',
        label: 'Santarem (BRT -03:00)'
    },
    {
        name: 'America/Sao_Paulo',
        offset: '-03:00',
        altname: 'Sao Paulo, Brazil',
        abbrev: 'BRT',
        label: 'Sao Paulo (BRT -03:00)'
    },
    {
        name: 'America/Punta_Arenas',
        offset: '-03:00',
        altname: 'Punta Arenas Time',
        abbrev: 'CLT',
        label: 'America/Punta_Arenas (CLT -03:00)'
    },
    {
        name: 'America/Santiago',
        offset: '-03:00',
        altname: 'Santiago, Chile',
        abbrev: 'CLST',
        label: 'Santiago (CLST -03:00)'
    },
    {
        name: 'Atlantic/Stanley',
        offset: '-03:00',
        altname: 'Falkland Islands Time',
        abbrev: 'FKT',
        label: 'Atlantic/Stanley (FKT -03:00)'
    },
    {
        name: 'America/Cayenne',
        offset: '-03:00',
        altname: 'Cayenne, French Guiana',
        abbrev: 'GFT',
        label: 'Cayenne (GFT -03:00)'
    },
    {
        name: 'America/Godthab',
        offset: '-03:00',
        altname: 'Godthab, Greenland',
        abbrev: 'WGT',
        label: 'Godthab (WGT -03:00)'
    },
    {
        name: 'America/Asuncion',
        offset: '-03:00',
        altname: 'Asuncion, Paraguay',
        abbrev: 'PYT',
        label: 'Asuncion (PYT -03:00)'
    },
    {
        name: 'America/Miquelon',
        offset: '-03:00',
        altname: 'Miquelon, Saint Pierre and Miquelon',
        abbrev: 'PMST',
        label: 'Miquelon (PMST -03:00)'
    },
    {
        name: 'America/Paramaribo',
        offset: '-03:00',
        altname: 'Paramaribo, Suriname',
        abbrev: 'SRT',
        label: 'Paramaribo (SRT -03:00)'
    },
    {
        name: 'America/Montevideo',
        offset: '-03:00',
        altname: 'Montevideo, Uruguay',
        abbrev: 'UYT',
        label: 'Montevideo (UYT -03:00)'
    },
    {
        name: 'America/Noronha',
        offset: '-02:00',
        altname: 'Noronha, Brazil',
        abbrev: 'FNT',
        label: 'Noronha (FNT -02:00)'
    },
    {
        name: 'Atlantic/South_Georgia',
        offset: '-02:00',
        altname: 'South Georgia and the South Sandwich Islands',
        abbrev: 'GST',
        label: 'South Georgia (GST -02:00)'
    },
    {
        name: 'Atlantic/Cape_Verde',
        offset: '+01:00',
        altname: 'Cape Verde',
        abbrev: 'CVT',
        label: 'Cape Verde (CVT +01:00)'
    },
    {
        name: 'America/Scoresbysund',
        offset: '-01:00',
        altname: 'Scoresbysund, Greenland',
        abbrev: 'EGT',
        label: 'Scoresbysund (EGT -01:00)'
    },
    {
        name: 'Atlantic/Azores',
        offset: '-01:00',
        altname: 'Azores, Portugal',
        abbrev: 'AZOT',
        label: 'Azores (AZOT -01:00)'
    },
    {
        name: 'Africa/Abidjan',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Abidjan (GMT +0.00)'
    },
    {
        name: 'Africa/Accra',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Accra (GMT +0.00)'
    },
    {
        name: 'Africa/Bamako',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Bamako (GMT +0.00)'
    },
    {
        name: 'Africa/Banjul',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Banjul (GMT +0.00)'
    },
    {
        name: 'Africa/Bissau',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Bissau (GMT +0.00)'
    },
    {
        name: 'Africa/Conakry',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Conakry (GMT +0.00)'
    },
    {
        name: 'Africa/Dakar',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Dakar (GMT +0.00)'
    },
    {
        name: 'Africa/Freetown',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Freetown (GMT +0.00)'
    },
    {
        name: 'Africa/Lome',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Lome (GMT +0.00)'
    },
    {
        name: 'Africa/Monrovia',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Monrovia (GMT +0.00)'
    },
    {
        name: 'Africa/Nouakchott',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Nouakchott (GMT +0.00)'
    },
    {
        name: 'Africa/Ouagadougou',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Ouagadougou (GMT +0.00)'
    },
    {
        name: 'Africa/Sao_Tome',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Africa/Sao Tome (GMT +0.00)'
    },
    {
        name: 'America/Danmarkshavn',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'America/Danmarkshavn (GMT +0.00)'
    },
    {
        name: 'Antarctica/Troll',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Antarctica/Troll (GMT +0.00)'
    },
    {
        name: 'Atlantic/Canary',
        offset: '+0.00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Atlantic/Canary (WET +0.00)'
    },
    {
        name: 'Atlantic/Faroe',
        offset: '+0.00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Atlantic/Faroe (WET +0.00)'
    },
    {
        name: 'Atlantic/Madeira',
        offset: '+0.00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Atlantic/Madeira (WET +0.00)'
    },
    {
        name: 'Atlantic/Reykjavik',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Atlantic/Reykjavik (GMT +0.00)'
    },
    {
        name: 'Atlantic/St_Helena',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Atlantic/St Helena (GMT +0.00)'
    },
    {
        name: 'Europe/Dublin',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Europe/Dublin (GMT +0.00)'
    },
    {
        name: 'Europe/Guernsey',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Europe/Guernsey (GMT +0.00)'
    },
    {
        name: 'Europe/Isle_of_Man',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Europe/Isle of Man (GMT +0.00)'
    },
    {
        name: 'Europe/Jersey',
        offset: '+0.00',
        altname: 'Greenwich Mean Time',
        abbrev: 'GMT',
        label: 'Europe/Jersey (GMT +0.00)'
    },
    {
        name: 'Europe/Lisbon',
        offset: '+0.00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Europe/Lisbon (WET +0.00)'
    },
    {
        name: 'Europe/Tirane',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Tirane (CET +01:00)'
    },
    {
        name: 'Africa/Algiers',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Africa/Algiers (CET +01:00)'
    },
    {
        name: 'Europe/Andorra',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Andorra (CET +01:00)'
    },
    {
        name: 'Africa/Luanda',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Luanda (WAT +01:00)'
    },
    {
        name: 'Europe/Vienna',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Vienna (CET +01:00)'
    },
    {
        name: 'Europe/Brussels',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Brussels (CET +01:00)'
    },
    {
        name: 'Africa/Porto-Novo',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Porto-Novo (WAT +01:00)'
    },
    {
        name: 'Europe/Sarajevo',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Sarajevo (CET +01:00)'
    },
    {
        name: 'Africa/Douala',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Douala (WAT +01:00)'
    },
    {
        name: 'Africa/Bangui',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Bangui (WAT +01:00)'
    },
    {
        name: 'Africa/Ndjamena',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Ndjamena (WAT +01:00)'
    },
    {
        name: 'Europe/Zagreb',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Zagreb (CET +01:00)'
    },
    {
        name: 'Europe/Prague',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Prague (CET +01:00)'
    },
    {
        name: 'Africa/Kinshasa',
        offset: '+01:00',
        altname: 'Western African Time',
        abbrev: 'WAT',
        label: 'Africa/Kinshasa (WAT +01:00)'
    },
    {
        name: 'Europe/Copenhagen',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Copenhagen (CET +01:00)'
    },
    {
        name: 'Africa/Malabo',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Malabo (WAT +01:00)'
    },
    {
        name: 'Africa/Libreville',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Libreville (WAT +01:00)'
    },
    {
        name: 'Europe/Berlin',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Berlin (CET +01:00)'
    },
    {
        name: 'Europe/Busingen',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Busingen (CET +01:00)'
    },
    {
        name: 'Europe/Gibraltar',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Gibraltar (CET +01:00)'
    },
    {
        name: 'Europe/Budapest',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Budapest (CET +01:00)'
    },
    {
        name: 'Europe/Rome',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Rome (CET +01:00)'
    },
    {
        name: 'Europe/Vaduz',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Vaduz (CET +01:00)'
    },
    {
        name: 'Europe/Luxembourg',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Luxembourg (CET +01:00)'
    },
    {
        name: 'Europe/Skopje',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Skopje (CET +01:00)'
    },
    {
        name: 'Europe/Malta',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Malta (CET +01:00)'
    },
    {
        name: 'Europe/Monaco',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Monaco (CET +01:00)'
    },
    {
        name: 'Europe/Podgorica',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Podgorica (CET +01:00)'
    },
    {
        name: 'Africa/Casablanca',
        offset: '+01:00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Africa/Casablanca (WET +01:00)'
    },
    {
        name: 'Europe/Amsterdam',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Amsterdam (CET +01:00)'
    },
    {
        name: 'Africa/Niamey',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Niamey (WAT +01:00)'
    },
    {
        name: 'Africa/Lagos',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Lagos (WAT +01:00)'
    },
    {
        name: 'Europe/Oslo',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Oslo (CET +01:00)'
    },
    {
        name: 'Europe/Warsaw',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Warsaw (CET +01:00)'
    },
    {
        name: 'Africa/Brazzaville',
        offset: '+01:00',
        altname: 'West Africa Time',
        abbrev: 'WAT',
        label: 'Africa/Brazzaville (WAT +01:00)'
    },
    {
        name: 'Europe/San_Marino',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/San_Marino (CET +01:00)'
    },
    {
        name: 'Europe/Belgrade',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Belgrade (CET +01:00)'
    },
    {
        name: 'Europe/Bratislava',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Bratislava (CET +01:00)'
    },
    {
        name: 'Europe/Ljubljana',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Ljubljana (CET +01:00)'
    },
    {
        name: 'Africa/Ceuta',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Africa/Ceuta (CET +01:00)'
    },
    {
        name: 'Europe/Madrid',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Madrid (CET +01:00)'
    },
    {
        name: 'Arctic/Longyearbyen',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Arctic/Longyearbyen (CET +01:00)'
    },
    {
        name: 'Europe/Stockholm',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Stockholm (CET +01:00)'
    },
    {
        name: 'Europe/Zurich',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Zurich (CET +01:00)'
    },
    {
        name: 'Africa/Tunis',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Africa/Tunis (CET +01:00)'
    },
    {
        name: 'Europe/Vatican',
        offset: '+01:00',
        altname: 'Central European Time',
        abbrev: 'CET',
        label: 'Europe/Vatican (CET +01:00)'
    },
    {
        name: 'Africa/El_Aaiun',
        offset: '+01:00',
        altname: 'Western European Time',
        abbrev: 'WET',
        label: 'Africa/El_Aaiun (WET +01:00)'
    },
    {
        name: 'Europe/Mariehamn',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Mariehamn (EET +02:00)'
    },
    {
        name: 'Africa/Gaborone',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Gaborone (CAT +02:00)'
    },
    {
        name: 'Europe/Sofia',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Sofia (EET +02:00)'
    },
    {
        name: 'Africa/Bujumbura',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Bujumbura (CAT +02:00)'
    },
    {
        name: 'Asia/Famagusta',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Famagusta (EET +02:00)'
    },
    {
        name: 'Asia/Nicosia',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Nicosia (EET +02:00)'
    },
    {
        name: 'Africa/Lubumbashi',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Lubumbashi (CAT +02:00)'
    },
    {
        name: 'Africa/Cairo',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Africa/Cairo (EET +02:00)'
    },
    {
        name: 'Europe/Tallinn',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Tallinn (EET +02:00)'
    },
    {
        name: 'Europe/Helsinki',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Helsinki (EET +02:00)'
    },
    {
        name: 'Europe/Athens',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Athens (EET +02:00)'
    },
    {
        name: 'Asia/Jerusalem',
        offset: '+02:00',
        altname: 'Israel Standard Time',
        abbrev: 'IST',
        label: 'Asia/Jerusalem (IST +02:00)'
    },
    {
        name: 'Asia/Amman',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Amman (EET +02:00)'
    },
    {
        name: 'Europe/Riga',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Riga (EET +02:00)'
    },
    {
        name: 'Asia/Beirut',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Beirut (EET +02:00)'
    },
    {
        name: 'Africa/Maseru',
        offset: '+02:00',
        altname: 'South Africa Standard Time',
        abbrev: 'SAST',
        label: 'Africa/Maseru (SAST +02:00)'
    },
    {
        name: 'Africa/Tripoli',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Africa/Tripoli (EET +02:00)'
    },
    {
        name: 'Europe/Vilnius',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Vilnius (EET +02:00)'
    },
    {
        name: 'Africa/Blantyre',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Blantyre (CAT +02:00)'
    },
    {
        name: 'Europe/Chisinau',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Chisinau (EET +02:00)'
    },
    {
        name: 'Africa/Maputo',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Maputo (CAT +02:00)'
    },
    {
        name: 'Africa/Windhoek',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Windhoek (CAT +02:00)'
    },
    {
        name: 'Asia/Gaza',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Gaza (EET +02:00)'
    },
    {
        name: 'Asia/Hebron',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Hebron (EET +02:00)'
    },
    {
        name: 'Europe/Bucharest',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Bucharest (EET +02:00)'
    },
    {
        name: 'Europe/Kaliningrad',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Kaliningrad (EET +02:00)'
    },
    {
        name: 'Africa/Kigali',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Kigali (CAT +02:00)'
    },
    {
        name: 'Africa/Johannesburg',
        offset: '+02:00',
        altname: 'South Africa Standard Time',
        abbrev: 'SAST',
        label: 'Africa/Johannesburg (SAST +02:00)'
    },
    {
        name: 'Africa/Khartoum',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Africa/Khartoum (EET +02:00)'
    },
    {
        name: 'Africa/Mbabane',
        offset: '+02:00',
        altname: 'South Africa Standard Time',
        abbrev: 'SAST',
        label: 'Africa/Mbabane (SAST +02:00)'
    },
    {
        name: 'Asia/Damascus',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Asia/Damascus (EET +02:00)'
    },
    {
        name: 'Europe/Kiev',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Kiev (EET +02:00)'
    },
    {
        name: 'Europe/Uzhgorod',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Uzhgorod (EET +02:00)'
    },
    {
        name: 'Europe/Zaporozhye',
        offset: '+02:00',
        altname: 'Eastern European Time',
        abbrev: 'EET',
        label: 'Europe/Zaporozhye (EET +02:00)'
    },
    {
        name: 'Africa/Lusaka',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Lusaka (CAT +02:00)'
    },
    {
        name: 'Africa/Harare',
        offset: '+02:00',
        altname: 'Central Africa Time',
        abbrev: 'CAT',
        label: 'Africa/Harare (CAT +02:00)'
    },
    {
        name: 'Antarctica/Syowa',
        offset: '+03:00',
        altname: 'Syowa Time',
        abbrev: 'SYOT',
        label: 'Antarctica/Syowa (SYOT +03:00)'
    },
    {
        name: 'Asia/Bahrain',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Bahrain (AST +03:00)'
    },
    {
        name: 'Europe/Minsk',
        offset: '+03:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Minsk (MSK +03:00)'
    },
    {
        name: 'Indian/Comoro',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Indian/Comoro (EAT +03:00)'
    },
    {
        name: 'Africa/Djibouti',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Djibouti (EAT +03:00)'
    },
    {
        name: 'Africa/Asmara',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Asmara (EAT +03:00)'
    },
    {
        name: 'Africa/Addis_Ababa',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Addis_Ababa (EAT +03:00)'
    },
    {
        name: 'Asia/Baghdad',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Baghdad (AST +03:00)'
    },
    {
        name: 'Africa/Nairobi',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Nairobi (EAT +03:00)'
    },
    {
        name: 'Asia/Kuwait',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Kuwait (AST +03:00)'
    },
    {
        name: 'Indian/Antananarivo',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Indian/Antananarivo (EAT +03:00)'
    },
    {
        name: 'Indian/Mayotte',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Indian/Mayotte (EAT +03:00)'
    },
    {
        name: 'Asia/Qatar',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Qatar (AST +03:00)'
    },
    {
        name: 'Europe/Kirov',
        offset: '+03:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Kirov (MSK +03:00)'
    },
    {
        name: 'Europe/Moscow',
        offset: '+03:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Moscow (MSK +03:00)'
    },
    {
        name: 'Asia/Riyadh',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Riyadh (AST +03:00)'
    },
    {
        name: 'Africa/Mogadishu',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Mogadishu (EAT +03:00)'
    },
    {
        name: 'Africa/Juba',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Juba (EAT +03:00)'
    },
    {
        name: 'Africa/Dar_es_Salaam',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Dar_es_Salaam (EAT +03:00)'
    },
    {
        name: 'Europe/Istanbul',
        offset: '+03:00',
        altname: 'Turkey Time',
        abbrev: 'TRT',
        label: 'Europe/Istanbul (TRT +03:00)'
    },
    {
        name: 'Africa/Kampala',
        offset: '+03:00',
        altname: 'East Africa Time',
        abbrev: 'EAT',
        label: 'Africa/Kampala (EAT +03:00)'
    },
    {
        name: 'Europe/Simferopol',
        offset: '+03:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Simferopol (MSK +03:00)'
    },
    {
        name: 'Asia/Aden',
        offset: '+03:00',
        altname: 'Arabian Standard Time',
        abbrev: 'AST',
        label: 'Asia/Aden (AST +03:00)'
    },
    {
        name: 'Asia/Tehran',
        offset: '+03:30',
        altname: 'Iran Standard Time',
        abbrev: 'IRST',
        label: 'Asia/Tehran (IRST +03:30)'
    },
    {
        name: 'Asia/Yerevan',
        offset: '+04:00',
        altname: 'Armenia Time',
        abbrev: 'AMT',
        label: 'Asia/Yerevan (AMT +04:00)'
    },
    {
        name: 'Asia/Baku',
        offset: '+04:00',
        altname: 'Azerbaijan Time',
        abbrev: 'AZT',
        label: 'Asia/Baku (AZT +04:00)'
    },
    {
        name: 'Asia/Tbilisi',
        offset: '+04:00',
        altname: 'Georgia Time',
        abbrev: 'GET',
        label: 'Asia/Tbilisi (GET +04:00)'
    },
    {
        name: 'Indian/Mauritius',
        offset: '+04:00',
        altname: 'Mauritius Time',
        abbrev: 'MUT',
        label: 'Indian/Mauritius (MUT +04:00)'
    },
    {
        name: 'Asia/Muscat',
        offset: '+04:00',
        altname: 'Gulf Standard Time',
        abbrev: 'GST',
        label: 'Asia/Muscat (GST +04:00)'
    },
    {
        name: 'Indian/Reunion',
        offset: '+04:00',
        altname: 'Reunion Time',
        abbrev: 'RET',
        label: 'Indian/Reunion (RET +04:00)'
    },
    {
        name: 'Europe/Astrakhan',
        offset: '+04:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Astrakhan (MSK +04:00)'
    },
    {
        name: 'Europe/Samara',
        offset: '+04:00',
        altname: 'Samara Time',
        abbrev: 'SAMT',
        label: 'Europe/Samara (SAMT +04:00)'
    },
    {
        name: 'Europe/Saratov',
        offset: '+04:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Saratov (MSK +04:00)'
    },
    {
        name: 'Europe/Ulyanovsk',
        offset: '+04:00',
        altname: 'Moscow Standard Time',
        abbrev: 'MSK',
        label: 'Europe/Ulyanovsk (MSK +04:00)'
    },
    {
        name: 'Europe/Volgograd',
        offset: '+04:00',
        altname: 'Volgograd Time',
        abbrev: 'VOLT',
        label: 'Europe/Volgograd (VOLT +04:00)'
    },
    {
        name: 'Indian/Mahe',
        offset: '+04:00',
        altname: 'Seychelles Time',
        abbrev: 'SCT',
        label: 'Indian/Mahe (SCT +04:00)'
    },
    {
        name: 'Asia/Dubai',
        offset: '+04:00',
        altname: 'Gulf Standard Time',
        abbrev: 'GST',
        label: 'Asia/Dubai (GST +04:00)'
    },
    {
        name: 'Asia/Kabul',
        offset: '+04:30',
        altname: 'Afghanistan Time',
        abbrev: 'AFT',
        label: 'Asia/Kabul (AFT +04:30)'
    },
    {
        name: 'Antarctica/Mawson',
        offset: '+05:00',
        altname: 'Mawson Time',
        abbrev: 'MAWT',
        label: 'Antarctica/Mawson (MAWT +05:00)'
    },
    {
        name: 'Indian/Kerguelen',
        offset: '+05:00',
        altname: 'French Southern and Antarctic Time',
        abbrev: 'TFT',
        label: 'Indian/Kerguelen (TFT +05:00)'
    },
    {
        name: 'Asia/Aqtau',
        offset: '+05:00',
        altname: 'Aqtau Time',
        abbrev: 'AQTT',
        label: 'Asia/Aqtau (AQTT +05:00)'
    },
    {
        name: 'Asia/Aqtobe',
        offset: '+05:00',
        altname: 'Aqtobe Time',
        abbrev: 'AQTT',
        label: 'Asia/Aqtobe (AQTT +05:00)'
    },
    {
        name: 'Asia/Atyrau',
        offset: '+05:00',
        altname: 'Aqtau Time',
        abbrev: 'AQTT',
        label: 'Asia/Atyrau (AQTT +05:00)'
    },
    {
        name: 'Asia/Oral',
        offset: '+05:00',
        altname: 'Oral Time',
        abbrev: 'ORAT',
        label: 'Asia/Oral (ORAT +05:00)'
    },
    {
        name: 'Asia/Qyzylorda',
        offset: '+05:00',
        altname: 'Qyzylorda Time',
        abbrev: 'QYZT',
        label: 'Asia/Qyzylorda (QYZT +05:00)'
    },
    {
        name: 'Indian/Maldives',
        offset: '+05:00',
        altname: 'Maldives Time',
        abbrev: 'MVT',
        label: 'Indian/Maldives (MVT +05:00)'
    },
    {
        name: 'Asia/Karachi',
        offset: '+05:00',
        altname: 'Pakistan Standard Time',
        abbrev: 'PKT',
        label: 'Asia/Karachi (PKT +05:00)'
    },
    {
        name: 'Asia/Yekaterinburg',
        offset: '+05:00',
        altname: 'Yekaterinburg Time',
        abbrev: 'YEKT',
        label: 'Asia/Yekaterinburg (YEKT +05:00)'
    },
    {
        name: 'Asia/Dushanbe',
        offset: '+05:00',
        altname: 'Tajikistan Time',
        abbrev: 'TJT',
        label: 'Asia/Dushanbe (TJT +05:00)'
    },
    {
        name: 'Asia/Ashgabat',
        offset: '+05:00',
        altname: 'Turkmenistan Time',
        abbrev: 'TMT',
        label: 'Asia/Ashgabat (TMT +05:00)'
    },
    {
        name: 'Asia/Samarkand',
        offset: '+05:00',
        altname: 'Uzbekistan Time',
        abbrev: 'UZT',
        label: 'Asia/Samarkand (UZT +05:00)'
    },
    {
        name: 'Asia/Tashkent',
        offset: '+05:00',
        altname: 'Uzbekistan Time',
        abbrev: 'UZT',
        label: 'Asia/Tashkent (UZT +05:00)'
    },
    {
        name: 'Asia/Kolkata',
        offset: '+05:30',
        altname: 'India Standard Time',
        abbrev: 'IST',
        label: 'Asia/Kolkata (IST +05:30)'
    },
    {
        name: 'Asia/Colombo',
        offset: '+05:30',
        altname: 'India Standard Time',
        abbrev: 'IST',
        label: 'Asia/Colombo (IST +05:30)'
    },
    {
        name: 'Asia/Kathmandu',
        offset: '+05:45',
        altname: 'Nepal Time',
        abbrev: 'NPT',
        label: 'Asia/Kathmandu (NPT +05:45)'
    },
    {
        name: 'Antarctica/Vostok',
        offset: '+06:00',
        altname: 'Vostok Time',
        abbrev: 'VOST',
        label: 'Antarctica/Vostok (VOST +06:00)'
    },
    {
        name: 'Asia/Dhaka',
        offset: '+06:00',
        altname: 'Bangladesh Standard Time',
        abbrev: 'BST',
        label: 'Asia/Dhaka (BST +06:00)'
    },
    {
        name: 'Asia/Thimphu',
        offset: '+06:00',
        altname: 'Bhutan Time',
        abbrev: 'BTT',
        label: 'Asia/Thimphu (BTT +06:00)'
    },
    {
        name: 'Indian/Chagos',
        offset: '+06:00',
        altname: 'Indian Ocean Time',
        abbrev: 'IOT',
        label: 'Indian/Chagos (IOT +06:00)'
    },
    {
        name: 'Asia/Urumqi',
        offset: '+06:00',
        altname: 'Urumqi Time',
        abbrev: 'URUT',
        label: 'Asia/Urumqi (URUT +06:00)'
    },
    {
        name: 'Asia/Almaty',
        offset: '+06:00',
        altname: 'Alma-Ata Time',
        abbrev: 'ALMT',
        label: 'Asia/Almaty (ALMT +06:00)'
    },
    {
        name: 'Asia/Qostanay',
        offset: '+06:00',
        altname: 'Qostanay Time',
        abbrev: 'QYZT',
        label: 'Asia/Qostanay (QYZT +06:00)'
    },
    {
        name: 'Asia/Bishkek',
        offset: '+06:00',
        altname: 'Kyrgyzstan Time',
        abbrev: 'KGT',
        label: 'Asia/Bishkek (KGT +06:00)'
    },
    {
        name: 'Asia/Omsk',
        offset: '+06:00',
        altname: 'Omsk Time',
        abbrev: 'OMST',
        label: 'Asia/Omsk (OMST +06:00)'
    },
    {
        name: 'Indian/Cocos',
        offset: '+06:30',
        altname: 'Cocos Islands Time',
        abbrev: 'CCT',
        label: 'Indian/Cocos (CCT +06:30)'
    },
    {
        name: 'Asia/Yangon',
        offset: '+06:30',
        altname: 'Myanmar Time',
        abbrev: 'MMT',
        label: 'Asia/Yangon (MMT +06:30)'
    },
    {
        name: 'Antarctica/Davis',
        offset: '+07:00',
        altname: 'Davis Time',
        abbrev: 'DAVT',
        label: 'Antarctica/Davis (DAVT +07:00)'
    },
    {
        name: 'Asia/Phnom_Penh',
        offset: '+07:00',
        altname: 'Indochina Time',
        abbrev: 'ICT',
        label: 'Asia/Phnom_Penh (ICT +07:00)'
    },
    {
        name: 'Indian/Christmas',
        offset: '+07:00',
        altname: 'Christmas Island Time',
        abbrev: 'CXT',
        label: 'Indian/Christmas (CXT +07:00)'
    },
    {
        name: 'Asia/Jakarta',
        offset: '+07:00',
        altname: 'Indonesia Western Time',
        abbrev: 'WIB',
        label: 'Asia/Jakarta (WIB +07:00)'
    },
    {
        name: 'Asia/Pontianak',
        offset: '+07:00',
        altname: 'Indonesia Western Time',
        abbrev: 'WIB',
        label: 'Asia/Pontianak (WIB +07:00)'
    },
    {
        name: 'Asia/Vientiane',
        offset: '+07:00',
        altname: 'Indochina Time',
        abbrev: 'ICT',
        label: 'Asia/Vientiane (ICT +07:00)'
    },
    {
        name: 'Asia/Hovd',
        offset: '+07:00',
        altname: 'Hovd Time',
        abbrev: 'HOVT',
        label: 'Asia/Hovd (HOVT +07:00)'
    },
    {
        name: 'Asia/Barnaul',
        offset: '+07:00',
        altname: 'Barnaul Time',
        abbrev: 'KRAT',
        label: 'Asia/Barnaul (KRAT +07:00)'
    },
    {
        name: 'Asia/Krasnoyarsk',
        offset: '+07:00',
        altname: 'Krasnoyarsk Time',
        abbrev: 'KRAT',
        label: 'Asia/Krasnoyarsk (KRAT +07:00)'
    },
    {
        name: 'Asia/Novokuznetsk',
        offset: '+07:00',
        altname: 'Novokuznetsk Time',
        abbrev: 'NOVT',
        label: 'Asia/Novokuznetsk (NOVT +07:00)'
    },
    {
        name: 'Asia/Novosibirsk',
        offset: '+07:00',
        altname: 'Novosibirsk Time',
        abbrev: 'NOVT',
        label: 'Asia/Novosibirsk (NOVT +07:00)'
    },
    {
        name: 'Asia/Tomsk',
        offset: '+07:00',
        altname: 'Tomsk Time',
        abbrev: 'KRAT',
        label: 'Asia/Tomsk (KRAT +07:00)'
    },
    {
        name: 'Asia/Bangkok',
        offset: '+07:00',
        altname: 'Indochina Time',
        abbrev: 'ICT',
        label: 'Asia/Bangkok (ICT +07:00)'
    },
    {
        name: 'Asia/Ho_Chi_Minh',
        offset: '+07:00',
        altname: 'Indochina Time',
        abbrev: 'ICT',
        label: 'Asia/Ho_Chi_Minh (ICT +07:00)'
    },
    {
        name: 'Antarctica/Casey',
        offset: '+08:00',
        altname: 'Casey Time',
        abbrev: 'CAST',
        label: 'Antarctica/Casey (CAST +08:00)'
    },
    {
        name: 'Australia/Perth',
        offset: '+08:00',
        altname: 'Australian Western Standard Time',
        abbrev: 'AWST',
        label: 'Australia/Perth (AWST +08:00)'
    },
    {
        name: 'Asia/Brunei',
        offset: '+08:00',
        altname: 'Brunei Darussalam Time',
        abbrev: 'BNT',
        label: 'Asia/Brunei (BNT +08:00)'
    },
    {
        name: 'Asia/Shanghai',
        offset: '+08:00',
        altname: 'China Standard Time',
        abbrev: 'CST',
        label: 'Asia/Shanghai (CST +08:00)'
    },
    {
        name: 'Asia/Hong_Kong',
        offset: '+08:00',
        altname: 'Hong Kong Time',
        abbrev: 'HKT',
        label: 'Asia/Hong_Kong (HKT +08:00)'
    },
    {
        name: 'Asia/Makassar',
        offset: '+08:00',
        altname: 'Central Indonesia Time',
        abbrev: 'WITA',
        label: 'Asia/Makassar (WITA +08:00)'
    },
    {
        name: 'Asia/Macau',
        offset: '+08:00',
        altname: 'Macau Time',
        abbrev: 'MOT',
        label: 'Asia/Macau (MOT +08:00)'
    },
    {
        name: 'Asia/Kuala_Lumpur',
        offset: '+08:00',
        altname: 'Malaysia Time',
        abbrev: 'MYT',
        label: 'Asia/Kuala_Lumpur (MYT +08:00)'
    },
    {
        name: 'Asia/Kuching',
        offset: '+08:00',
        altname: 'Malaysia Time',
        abbrev: 'MYT',
        label: 'Asia/Kuching (MYT +08:00)'
    },
    {
        name: 'Asia/Choibalsan',
        offset: '+08:00',
        altname: 'Choibalsan Time',
        abbrev: 'CHOT',
        label: 'Asia/Choibalsan (CHOT +08:00)'
    },
    {
        name: 'Asia/Ulaanbaatar',
        offset: '+08:00',
        altname: 'Ulaanbaatar Time',
        abbrev: 'ULAT',
        label: 'Asia/Ulaanbaatar (ULAT +08:00)'
    },
    {
        name: 'Asia/Manila',
        offset: '+08:00',
        altname: 'Philippine Time',
        abbrev: 'PHT',
        label: 'Asia/Manila (PHT +08:00)'
    },
    {
        name: 'Asia/Irkutsk',
        offset: '+08:00',
        altname: 'Irkutsk Time',
        abbrev: 'IRKT',
        label: 'Asia/Irkutsk (IRKT +08:00)'
    },
    {
        name: 'Asia/Singapore',
        offset: '+08:00',
        altname: 'Singapore Time',
        abbrev: 'SGT',
        label: 'Asia/Singapore (SGT +08:00)'
    },
    {
        name: 'Asia/Taipei',
        offset: '+08:00',
        altname: 'Taipei Standard Time',
        abbrev: 'CST',
        label: 'Asia/Taipei (CST +08:00)'
    },
    {
        name: 'Australia/Eucla',
        offset: '+08:45',
        altname: 'Australian Central Western Standard Time',
        abbrev: 'ACWST',
        label: 'Australia/Eucla (ACWST +08:45)'
    },
    {
        name: 'Asia/Dili',
        offset: '+09:00',
        altname: 'Timor-Leste Time',
        abbrev: 'TLT',
        label: 'Asia/Dili (TLT +09:00)'
    },
    {
        name: 'Asia/Jayapura',
        offset: '+09:00',
        altname: 'Indonesia Eastern Time',
        abbrev: 'WIT',
        label: 'Asia/Jayapura (WIT +09:00)'
    },
    {
        name: 'Asia/Tokyo',
        offset: '+09:00',
        altname: 'Japan Standard Time',
        abbrev: 'JST',
        label: 'Asia/Tokyo (JST +09:00)'
    },
    {
        name: 'Asia/Pyongyang',
        offset: '+09:00',
        altname: 'Pyongyang Time',
        abbrev: 'KST',
        label: 'Asia/Pyongyang (KST +09:00)'
    },
    {
        name: 'Pacific/Palau',
        offset: '+09:00',
        altname: 'Palau Time',
        abbrev: 'PWT',
        label: 'Pacific/Palau (PWT +09:00)'
    },
    {
        name: 'Asia/Chita',
        offset: '+09:00',
        altname: 'Yakutsk Time',
        abbrev: 'YAKT',
        label: 'Asia/Chita (YAKT +09:00)'
    },
    {
        name: 'Asia/Khandyga',
        offset: '+09:00',
        altname: 'Yakutsk Time',
        abbrev: 'YAKT',
        label: 'Asia/Khandyga (YAKT +09:00)'
    },
    {
        name: 'Asia/Yakutsk',
        offset: '+09:00',
        altname: 'Yakutsk Time',
        abbrev: 'YAKT',
        label: 'Asia/Yakutsk (YAKT +09:00)'
    },
    {
        name: 'Asia/Seoul',
        offset: '+09:00',
        altname: 'Korea Standard Time',
        abbrev: 'KST',
        label: 'Asia/Seoul (KST +09:00)'
    },
    {
        name: 'Australia/Darwin',
        offset: '+09:30',
        altname: 'Australian Central Standard Time',
        abbrev: 'ACST',
        label: 'Australia/Darwin (ACST +09:30)'
    },
    {
        name: 'Antarctica/DumontDUrville',
        offset: '+10:00',
        altname: 'Dumont d\'Urville Time\'',
        abbrev: 'DDUT',
        label: 'Antarctica/DumontDUrville (DDUT +10:00)'
    },
    {
        name: 'Australia/Brisbane',
        offset: '+10:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Brisbane (AEST +10:00)'
    },
    {
        name: 'Australia/Lindeman',
        offset: '+10:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Lindeman (AEST +10:00)'
    },
    {
        name: 'Pacific/Guam',
        offset: '+10:00',
        altname: 'Chamorro Standard Time',
        abbrev: 'ChST',
        label: 'Pacific/Guam (ChST +10:00)'
    },
    {
        name: 'Pacific/Chuuk',
        offset: '+10:00',
        altname: 'Chuuk Time',
        abbrev: 'CHUT',
        label: 'Pacific/Chuuk (CHUT +10:00)'
    },
    {
        name: 'Pacific/Saipan',
        offset: '+10:00',
        altname: 'Chamorro Standard Time',
        abbrev: 'ChST',
        label: 'Pacific/Saipan (ChST +10:00)'
    },
    {
        name: 'Pacific/Port_Moresby',
        offset: '+10:00',
        altname: 'Papua New Guinea Time',
        abbrev: 'PGT',
        label: 'Pacific/Port_Moresby (PGT +10:00)'
    },
    {
        name: 'Asia/Ust-Nera',
        offset: '+10:00',
        altname: 'Vladivostok Time',
        abbrev: 'VLAT',
        label: 'Asia/Ust-Nera (VLAT +10:00)'
    },
    {
        name: 'Asia/Vladivostok',
        offset: '+10:00',
        altname: 'Vladivostok Time',
        abbrev: 'VLAT',
        label: 'Asia/Vladivostok (VLAT +10:00)'
    },
    {
        name: 'Australia/Adelaide',
        offset: '+10:30',
        altname: 'Australian Central Standard Time',
        abbrev: 'ACST',
        label: 'Australia/Adelaide (ACST +10:30)'
    },
    {
        name: 'Australia/Broken_Hill',
        offset: '+10:30',
        altname: 'Australian Central Standard Time',
        abbrev: 'ACST',
        label: 'Australia/Broken_Hill (ACST +10:30)'
    },
    {
        name: 'Antarctica/Macquarie',
        offset: '+11:00',
        altname: 'Macquarie Island Time',
        abbrev: 'MIST',
        label: 'Antarctica/Macquarie (MIST +11:00)'
    },
    {
        name: 'Australia/Currie',
        offset: '+11:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Currie (AEST +11:00)'
    },
    {
        name: 'Australia/Hobart',
        offset: '+11:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Hobart (AEST +11:00)'
    },
    {
        name: 'Australia/Lord_Howe',
        offset: '+11:00',
        altname: 'Lord Howe Standard Time',
        abbrev: 'LHST',
        label: 'Australia/Lord_Howe (LHST +11:00)'
    },
    {
        name: 'Australia/Melbourne',
        offset: '+11:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Melbourne (AEST +11:00)'
    },
    {
        name: 'Australia/Sydney',
        offset: '+11:00',
        altname: 'Australian Eastern Standard Time',
        abbrev: 'AEST',
        label: 'Australia/Sydney (AEST +11:00)'
    },
    {
        name: 'Pacific/Kosrae',
        offset: '+11:00',
        altname: 'Kosrae Time',
        abbrev: 'KOST',
        label: 'Pacific/Kosrae (KOST +11:00)'
    },
    {
        name: 'Pacific/Pohnpei',
        offset: '+11:00',
        altname: 'Pohnpei Standard Time',
        abbrev: 'PONT',
        label: 'Pacific/Pohnpei (PONT +11:00)'
    },
    {
        name: 'Pacific/Noumea',
        offset: '+11:00',
        altname: 'New Caledonia Time',
        abbrev: 'NCT',
        label: 'Pacific/Noumea (NCT +11:00)'
    },
    {
        name: 'Pacific/Bougainville',
        offset: '+11:00',
        altname: 'Bougainville Standard Time',
        abbrev: 'BST',
        label: 'Pacific/Bougainville (BST +11:00)'
    },
    {
        name: 'Asia/Magadan',
        offset: '+11:00',
        altname: 'Magadan Time',
        abbrev: 'MAGT',
        label: 'Asia/Magadan (MAGT +11:00)'
    },
    {
        name: 'Asia/Sakhalin',
        offset: '+11:00',
        altname: 'Sakhalin Time',
        abbrev: 'SAKT',
        label: 'Asia/Sakhalin (SAKT +11:00)'
    },
    {
        name: 'Asia/Srednekolymsk',
        offset: '+11:00',
        altname: 'Magadan Time',
        abbrev: 'MAGT',
        label: 'Asia/Srednekolymsk (MAGT +11:00)'
    },
    {
        name: 'Pacific/Guadalcanal',
        offset: '+11:00',
        altname: 'Solomon Islands Time',
        abbrev: 'SBT',
        label: 'Pacific/Guadalcanal (SBT +11:00)'
    },
    {
        name: 'Pacific/Efate',
        offset: '+11:00',
        altname: 'Vanuatu Time',
        abbrev: 'VUT',
        label: 'Pacific/Efate (VUT +11:00)'
    },
    {
        name: 'Pacific/Tarawa',
        offset: '+12:00',
        altname: 'Gilbert Islands Time',
        abbrev: 'GILT',
        label: 'Pacific/Tarawa (GILT +12:00)'
    },
    {
        name: 'Pacific/Kwajalein',
        offset: '+12:00',
        altname: 'Marshall Islands Time',
        abbrev: 'MHT',
        label: 'Pacific/Kwajalein (MHT +12:00)'
    },
    {
        name: 'Pacific/Majuro',
        offset: '+12:00',
        altname: 'Marshall Islands Time',
        abbrev: 'MHT',
        label: 'Pacific/Majuro (MHT +12:00)'
    },
    {
        name: 'Pacific/Nauru',
        offset: '+12:00',
        altname: 'Nauru Time',
        abbrev: 'NRT',
        label: 'Pacific/Nauru (NRT +12:00)'
    },
    {
        name: 'Pacific/Norfolk',
        offset: '+12:00',
        altname: 'Norfolk Island Time',
        abbrev: 'NFT',
        label: 'Pacific/Norfolk (NFT +12:00)'
    },
    {
        name: 'Asia/Anadyr',
        offset: '+12:00',
        altname: 'Anadyr Time',
        abbrev: 'ANAT',
        label: 'Asia/Anadyr (ANAT +12:00)'
    },
    {
        name: 'Asia/Kamchatka',
        offset: '+12:00',
        altname: 'Kamchatka Time',
        abbrev: 'PETT',
        label: 'Asia/Kamchatka (PETT +12:00)'
    },
    {
        name: 'Pacific/Funafuti',
        offset: '+12:00',
        altname: 'Tuvalu Time',
        abbrev: 'TVT',
        label: 'Pacific/Funafuti (TVT +12:00)'
    },
    {
        name: 'Pacific/Wake',
        offset: '+12:00',
        altname: 'Wake Island Time',
        abbrev: 'WAKT',
        label: 'Pacific/Wake (WAKT +12:00)'
    },
    {
        name: 'Pacific/Wallis',
        offset: '+12:00',
        altname: 'Wallis and Futuna Time',
        abbrev: 'WFT',
        label: 'Pacific/Wallis (WFT +12:00)'
    },
    {
        name: 'Antarctica/McMurdo',
        offset: '+13:00',
        altname: 'New Zealand Standard Time',
        abbrev: 'NZST',
        label: 'Antarctica/McMurdo (NZST +13:00)'
    },
    {
        name: 'Pacific/Fiji',
        offset: '+13:00',
        altname: 'Fiji Time',
        abbrev: 'FJT',
        label: 'Pacific/Fiji (FJT +13:00)'
    },
    {
        name: 'Pacific/Enderbury',
        offset: '+13:00',
        altname: 'Phoenix Islands Time',
        abbrev: 'PHOT',
        label: 'Pacific/Enderbury (PHOT +13:00)'
    },
    {
        name: 'Pacific/Auckland',
        offset: '+13:00',
        altname: 'New Zealand Standard Time',
        abbrev: 'NZST',
        label: 'Pacific/Auckland (NZST +13:00)'
    },
    {
        name: 'Pacific/Fakaofo',
        offset: '+13:00',
        altname: 'Tokelau Time',
        abbrev: 'TKT',
        label: 'Pacific/Fakaofo (TKT +13:00)'
    },
    {
        name: 'Pacific/Tongatapu',
        offset: '+13:00',
        altname: 'Tonga Time',
        abbrev: 'TOT',
        label: 'Pacific/Tongatapu (TOT +13:00)'
    },
    {
        name: 'Pacific/Chatham',
        offset: '+13:45',
        altname: 'Chatham Standard Time',
        abbrev: 'CHAST',
        label: 'Pacific/Chatham (CHAST +13:45)'
    },
    {
        name: 'Pacific/Kiritimati',
        offset: '+14:00',
        altname: 'Line Islands Time',
        abbrev: 'LINT',
        label: 'Pacific/Kiritimati (LINT +14:00)'
    },
    {
        name: 'Pacific/Apia',
        offset: '+14:00',
        altname: 'Samoa Standard Time',
        abbrev: 'SST',
        label: 'Pacific/Apia (SST +14:00)'
    }
];
//# sourceMappingURL=data:application/json;base64,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